/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

function AppStoreIcon(props: IProps) {
  const { ...rest } = props;

  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_18119_39985)">
        <path
          d="M6.57 0H23.43C27.0586 0 30 2.94141 30 6.57V23.43C30 27.0586 27.0586 30 23.43 30H6.57C2.94141 30 0 27.0586 0 23.43V6.57C0 2.94141 2.94141 0 6.57 0Z"
          fill="url(#paint0_linear_18119_39985)"
        />
        <path
          d="M9.6144 21.7746L9.61722 21.7755L8.59148 23.5521C8.21706 24.2006 7.38784 24.4228 6.73933 24.0483C6.09081 23.6739 5.86862 22.8447 6.24304 22.1962L6.99866 20.8874L7.0712 20.7618C7.20069 20.5757 7.52026 20.2544 8.15952 20.3149C8.15952 20.3149 9.66386 20.4781 9.77272 21.26C9.77272 21.26 9.78749 21.5172 9.6144 21.7746ZM24.1624 17.2371H20.9639C20.746 17.2224 20.651 17.1446 20.6135 17.0994L20.6112 17.0953L17.1873 11.1649L17.1828 11.1678L16.9775 10.8734C16.641 10.3587 16.1066 11.675 16.1066 11.675C15.4685 13.1417 16.1972 14.8092 16.4511 15.3132L21.2068 23.5503C21.5811 24.1987 22.4103 24.421 23.059 24.0465C23.7074 23.6721 23.9297 22.8428 23.5551 22.1943L22.366 20.1346C22.343 20.0847 22.3029 19.9492 22.5467 19.9487H24.1624C24.9112 19.9487 25.5183 19.3416 25.5183 18.5928C25.5183 17.844 24.9112 17.2371 24.1624 17.2371ZM17.9498 19.0801C17.9498 19.0801 18.1206 19.9485 17.46 19.9485H5.63589C4.88706 19.9485 4.28003 19.3415 4.28003 18.5927C4.28003 17.8439 4.88706 17.2368 5.63589 17.2368H8.67573C9.16651 17.2085 9.28276 16.9251 9.28276 16.9251L9.28558 16.9265L13.2535 10.0537L13.2524 10.0535C13.3247 9.92069 13.2644 9.79518 13.254 9.77537L11.9435 7.50557C11.5691 6.85717 11.7913 6.02783 12.4398 5.65354C13.0883 5.27924 13.9175 5.50119 14.2919 6.14971L14.8997 7.2024L15.5064 6.15158C15.8808 5.50319 16.71 5.28088 17.3585 5.65541C18.007 6.02994 18.2292 6.85893 17.8548 7.50744L12.3332 17.0711C12.309 17.1294 12.3016 17.2208 12.4813 17.2368H15.7817L15.7825 17.269C15.7825 17.269 17.69 17.2987 17.9498 19.0801Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_18119_39985" x1="1500" y1="0" x2="1500" y2="3000" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17C9FB" />
          <stop offset="1" stopColor="#1A74E8" />
        </linearGradient>
        <clipPath id="clip0_18119_39985">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AppStoreIcon;
